import { css } from '@emotion/react';

import TributeCardView2 from './TributeCardView2';
import { ALL_TRIBUTE2_DEFS } from './tribute2Defs';

export default function TributeDebugPage2() {
  return (
    <div css={Styles.page}>
      <div css={Styles.row}>
        {ALL_TRIBUTE2_DEFS.map((t) => (
          <div key={t.defID} style={{ zoom: 4 }}>
            <TributeCardView2 card={t} />
          </div>
        ))}
      </div>
    </div>
  );
}

const Styles = {
  page: css({
    padding: 8,
  }),
  row: css({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  }),
};
